export enum RoomNameType {
  None = '',
  Json = 'json',
  Ics = 'ics',
}

export enum Theme {
  Default = 'default',
  DarkBlue = 'darkblue',
  Blue = 'blue',
  Purple = 'purple',
  Brown = 'brown',
  GreenGradient = 'green-gradient',
}

export const DEFAULT_LANGUAGE = 'cs'
export const DEFAULT_UPDATE_INTERVAL = 15 // minutes
export const DEFAULT_EVENT_INTERVAL = 24 // hours
export const DEFAULT_ERROR_RETRY_INTERVAL = 60 // seconds
export const DEFAULT_EVENTS_ROTATION_INTERVAL = 6 // seconds
